export type NewMessage = {
    content: string
}

export const emptyNewMessage: NewMessage = {
    content: ''
}